export const IDLE_TIME_MODAL_TEST_IDS = {
  IDLE_TIME_MODAL_STAY_LOGGED_IN_BUTTON: "idleTimeModal_stayLoggedInButton",
  IDLE_TIME_MODAL_LOG_OUT_BUTTON: "idleTimeModal_logOutButton",
};